import { createContext, use } from "react";

interface PortalHostContextValue {
  blockingLayerHost: HTMLDivElement | null;
  portalHost: HTMLDivElement | null;
}

const PortalHostContext = createContext<PortalHostContextValue>({
  blockingLayerHost: null,
  portalHost: null,
});

function usePortalHost() {
  return use(PortalHostContext).portalHost ?? undefined;
}

function useBlockingLayerHost() {
  return use(PortalHostContext).blockingLayerHost ?? undefined;
}

export {
  PortalHostContext,
  useBlockingLayerHost,
  usePortalHost,
  type PortalHostContextValue,
};
